import styled from 'styled-components';
import { FlexColumn } from '@equifinance/shared';
import { Application } from '../../../contexts/applications';

const OutstandingColumnContainer = styled(FlexColumn)`${({ theme }) => `
  width: 100%;
  max-width: 100%;
  gap: ${theme.padding[2]};
`}`;

const Divider = styled.span`${({ theme }) => `
  height: ${theme.borderWidth[1]};
  background: ${theme.colours.primary[7]};
`}`;

const ValueText = styled.span`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
`}`;

export default function OutstandingColumn({ row }: { row: Application }) {
  const { totalTasksOutstanding, totalChecklistOutstanding } = row;
  return (
    <OutstandingColumnContainer>
      <ValueText>
        {`Tasks: ${totalTasksOutstanding == null ? '-' : totalTasksOutstanding}`}
      </ValueText>
      <Divider />
      <ValueText>
        {`Checklist: ${totalChecklistOutstanding == null ? '-' : totalChecklistOutstanding}`}
      </ValueText>
    </OutstandingColumnContainer>
  );
}
